import { useCallback } from 'react';
import {
  canAccessItem,
  getDefaultItem,
  IPreferenceItem,
  preferenceItems,
} from '@/creditflowresearch/application/hooks/userPreferences/helpers';
import { withResolvedSegments } from '@/creditflowresearch/application/hooks/userPreferences/segmentPreferences';

const useGetDefaultPreferences = (
  accessibleProducts: string[],
  accessibleRegions: string[],
) => {
  const getDefaultItems = useCallback((items: IPreferenceItem[]) => {
    const defaultItem = getDefaultItem(
      items,
      (item) => canAccessItem(item, accessibleProducts, accessibleRegions),
    );
    const defaultChild = defaultItem?.children ? getDefaultItems(defaultItem.children) : {};

    return defaultItem ? { [defaultItem.fieldName]: [defaultItem.id], ...defaultChild } : {};
  }, [accessibleProducts, accessibleRegions]);

  return () => withResolvedSegments(getDefaultItems(preferenceItems));
};

export default useGetDefaultPreferences;
